import * as ACTION_TYPES from '../types';

let initialState = {
  userList: [],
  poolList: [],
  user: {},
  usersByQuery: [],
  loggedIn: false,
  sessionTimedOut: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_USERS:
      return {...state, userList: action.data};

    case ACTION_TYPES.DELETE_USER:
      let newList = state.userList.filter(user => user._id !== action.id);
      return {...state, userList: newList};

    case ACTION_TYPES.GET_USER_BY_ID:
      return {...state, user: action.data};

    case ACTION_TYPES.REQUEST:
      return {...state, loading: true};

    case ACTION_TYPES.DONE:
      return {...state, loading: false};

    case ACTION_TYPES.RESET_USERS:
      return {...state, userList: []};

    case ACTION_TYPES.GET_USER_BY_QUERY:
      return {...state, usersByQuery: action.data};

    case ACTION_TYPES.GET_FILTERED_USERS:
      return {...state, userList: action.data};

    case ACTION_TYPES.AUTHORIZE_SUCCESS:
      return {...state, loggedIn: true};

    case ACTION_TYPES.AUTHORIZE_FAIL:
      return {...state, loggedIn: false};

    case ACTION_TYPES.LOGOUT:
      return {...state, loggedIn: false};
    
    case ACTION_TYPES.SESSION_TIMED_OUT:
      return {...state, sessionTimedOut: action.data};  

    default:
      return state;
  }
};
